const accessRoute = {
  HOME: {
    path: "/home",
  },
};
export default accessRoute;
